export default class ShiftRecordBreakDto {
  constructor({ type, startTime, endTime } = {}) {
    /**
     * The type of break that was taken
     * @type {String}
     * @see {ShiftRecordBreakType} for valid range of values
     */
    this.type = type
    /**
     * Start time of block in 24 hr format
     * @type {String}
     * @example 08:30
     */
    this.startTime = startTime
    /**
     * End time of block in 24 hr format
     * @type {String}
     * @example 15:30
     */
    this.endTime = endTime
  }
}
